const GetLocalTime = function() {

  const config = {
    timer: 1000,
    defaultTimeZone: 'Europe/London'
  };

  //Check if IE11
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;



  //Get Time Display Element on the Page where the time will be injected
  const getElement = function () {
    const el = document.querySelectorAll('.local-time');
    return el;
  }

  //Get Element which get the Timezone dataset value from the server
  const timeZoneElement = function() {
    const el = document.querySelector('[data-timezone]');
    return el;
  }

  //Get Timezone based on the Dataset value of the element 
  const getTimeZone = function() {
    const tZoneEl = timeZoneElement();
    if(tZoneEl !== null) {
      const timeZone = (tZoneEl.dataset.timezone !== "") ? tZoneEl.dataset.timezone : config.defaultTimeZone; // Incase Timezone is not retrieved from server we are defaulting it to 'Europe/London'
      return timeZone;  
    }    
  }

  //Get Time based on the Timezone passed - Had to change for IE11 :(
  const localTime = document.querySelector('.local-time');
  var timeString = localTime.innerHTML;
  var LocalDate;
  var hours = parseInt(timeString.split(":")[0]);
  var minutes = parseInt(timeString.split(":")[1]);
  
  const  getTimeIE = function() {     
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth();
    const year = today.getFullYear();

    LocalDate = new Date(year, month, day, hours, minutes);    
    minutes = LocalDate.getTime() + minutes + 1000 * 60;
    hours = LocalDate.getHours();
    const newDate = new Date(minutes);
    hours = newDate.getHours();
    minutes = newDate.getMinutes();

    const hoursString = (hours < 10) ? '0' + hours : hours;
    const minutesString = (minutes < 10) ? '0' + minutes: minutes;

    timeString = hoursString + ":" + minutesString;

    return timeString;
  }

  const getTime = function() {
    const TimeZone = getTimeZone();
    const date = new Date();
    const timeStr = new Intl.DateTimeFormat('en-gb', {
      timeZone: TimeZone,
      hour: 'numeric',
      minute: 'numeric'
    }).format(date);

    return timeStr;
  }



  // Update the UI with the Time 
  const updateTimeUI = function() {
    const element = getElement();
    const currentTime = (!isIE11) ? getTime() : getTimeIE();    
    
    //Element returns a nodelist below we converting Nodelist to Array to loop through
    const elementArray = Array.prototype.slice.call(element);

    //Loop through Array created above to extract single element and updating its text content
    Array.prototype.forEach.call(elementArray, function(el, index) {
      el.innerHTML = currentTime;
    });    
  }
 
  //Initializing the script in app.js
  const init = function () { 
      updateTimeUI();

      config.timer = (!isIE11) ? 1000 : 60000;
      //self run this every minute to update the time
      setInterval(updateTimeUI, config.timer);
  }

  return {
    init: init,
    getTimeZone: getTimeZone
  }

};
